<template>
    <section class="page-section" v-loading="pageLoading">
                <div class="form-wrap">
                    <el-form size="small" ref="formData" :model="formData" label-width="80px" class="content-form">
                        <el-form-item label="图标" required :show-message="false">
                            <div class="category-pics-box margin-top-15">
                                <div class="pics-box">
                                    <el-upload
                                        :action="uploadPicUrl"
                                        list-type="picture-card"
                                        :file-list="formData.pics"
                                        accept=".png,.jpg,.jpeg"
                                        :limit="1"
                                        :on-preview="handlePicPreview"
                                        :on-remove="handlePicRemove"
                                        :on-success="handlePicSuccess"
                                        :on-error="handlePicError"
                                        :before-upload="handlePicBeforeUpload">
                                        <i class="el-icon-plus"></i>
                                    </el-upload>
                                </div>
                                <div class="tips">支持jpg、png格式，建议尺寸：100*100像素</div>
                            </div>
                        </el-form-item>
                        <el-form-item label="关键词" required>
                            <el-input v-model="formData.keyword" maxLength="8" class="w150"></el-input>
                        </el-form-item>
                        <el-form-item label="标题" required>
                            <el-input v-model="formData.title" maxLength="8" class="w150"></el-input>
                        </el-form-item>
                        <el-form-item label="链接至" required>
                            <el-select v-model="formData.redirectType" filterable clearable placeholder="请选择" @change="handleRedirectTypeChange">
                                <template v-for="(row, rowIndex) in redirectTypeOptions">
                                    <el-option :label="row.label" :value="row.value" :key="rowIndex"></el-option>
                                </template>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="服务" required v-if="formData.redirectType == 1">
                            <el-select v-model="formData.relationIdList" multiple filterable placeholder="请选择" class="w10000" :loading="optionsLoading" @change="handleGetRelatedGoodsList()">
                                <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="商品" required v-if="formData.redirectType == 3">
                            <el-select v-model="formData.relationIdList" multiple filterable placeholder="请选择" class="w10000" :loading="optionsLoading" @change="handleGetRelatedGoodsList()">
                                <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="一级分类" required v-if="formData.redirectType == 2 || formData.redirectType == 4">
                            <el-select v-model="formData.firstCategoryId" filterable clearable placeholder="请选择" class="w300" :loading="firstCategoryOptionsLoading" @change="handleFirstCategoryChange">
                                <el-option :label="item.name" :value="item.id" v-for="(item, index) in firstCategoryOptions" :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="二级分类" required v-if="(formData.redirectType == 2 || formData.redirectType == 4) && formData.firstCategoryId">
                            <el-select v-model="formData.secondCategoryId" filterable clearable placeholder="请选择" class="w300" :loading="secondCategoryOptionsLoading">
                                <el-option :label="item.name" :value="item.id" v-for="(item, index) in secondCategoryOptions" :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="详情页" required v-if="formData.redirectType == 5">
                            <el-select v-model="formData.productId" filterable placeholder="请选择" class="w300" :loading="optionsLoading">
                                <el-option v-for="item in options" :key="item.id" :label="item.title" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        
                        <template v-if="formData.redirectType == 1 || formData.redirectType == 3">
                            <el-table size="small" :data="commodityList.tableData" v-loading="commodityList.tableLoading" v-if="commodityList.tableData.length > 0">
                                <el-table-column :label="formData.redirectType == 1 ? '项目' : formData.redirectType == 3 ? '商品' : ''" width="400">
                                    <template slot-scope="scope">
                                        <div class="dialog-goods-title">
                                            <template v-if="formData.redirectType == 1">
                                                <div class="thumb-wrap">
                                                    <img :src="scope.row.pic" style="pointer-events: none;">
                                                </div>
                                                <p>{{ scope.row.name }}</p>
                                                <p>备注：{{ scope.row.remark }}</p>
                                            </template>
                                            <template v-if="formData.redirectType == 3">
                                                <div class="thumb-wrap">
                                                    <img :src="scope.row.mainPic" style="pointer-events: none;">
                                                </div>
                                                <p>{{ scope.row.name }}</p>
                                            </template>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="价格(人民币)" sortable sort-by="price">
                                    <template slot-scope="scope">
                                        <p>￥{{ scope.row.price }}</p>
                                        <p style="text-decoration: line-through;" v-if="scope.row.linePrice">￥{{ scope.row.linePrice }}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column label="价格(韩元)" sortable sort-by="koreaPrice">
                                    <template slot-scope="scope">
                                        <p>₩{{ scope.row.koreaPrice }}</p>
                                        <p style="text-decoration: line-through;" v-if="scope.row.lineKoreaPrice">₩{{ scope.row.lineKoreaPrice }}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column label="库存" width="80">
                                    <template slot-scope="scope">
                                        <p>{{ scope.row.stock }}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column label="总销量" width="60">
                                    <template slot-scope="scope">
                                        <template v-if="formData.redirectType == 1">
                                            <p>{{ scope.row.saleNum > 0 ? scope.row.saleNum : '-' }}</p>
                                        </template>
                                        <template v-if="formData.redirectType == 3">
                                            <p>{{ scope.row.sale > 0 ? scope.row.sale : '-' }}</p>
                                        </template>
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column label="关联时间" width="180">
                                    <template slot-scope="scope">
                                        <p>{{ scope.row.relationTime }}</p>
                                    </template>
                                </el-table-column> -->
                                <el-table-column label="操作" width="80" align="right">
                                    <template slot-scope="scope">
                                        <el-button size="small" type="text" @click="handleCommodityListRowRemove(scope.row, scope.$index)">解除关联</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>


                        <div class="margin-top-15">
                            <el-button type="primary" size="small" :loading="submitLoading" @click="handleSave">保存</el-button>
                            <el-button type="default" size="small" plain @click="pageLinkToComponentList">取消</el-button>
                        </div>
                    </el-form>
                </div>
            

        <!-- 图片预览 -->
        <el-dialog :visible.sync="previewDialogShow" custom-class="preview-image-dialog">
            <img width="100%" :src="previewDialogImageUrl" alt="">
        </el-dialog>
      </section>
</template>

<script>
    import { COMMON, uploadPath, shopComponentServiceDetail, commodityCategoryList, serviceManageList, commodityFilterList, shopPosterPageList, shopComponentServiceRecommendSaveOrUpdate } from '@/common/api';

    export default {
        name: 'shopComponentIndexAdd',
        data() {
            return {
                id: this.$route.query.id || '',

                pageLoading: false, // 页面loading

                formData: {
                    pics: [],
                    keyword: '',
                    title: '',
                    redirectType: '', // 关联类型
                    firstCategoryId: '',
                    secondCategoryId: '',
                    productId: '',
                    relationIdList: []
                },
                submitLoading: false,
                
                uploadPicUrl: uploadPath + '/module/uploadPic', // 图片上传地址
                previewDialogShow: false, // 预览图片 - 弹窗
                previewDialogImageUrl: '', // 预览图片 - url

                redirectTypeOptions: [
                    {
                        label: '服务',
                        value: 1
                    },
                    {
                        label: '服务分类',
                        value: 2
                    },
                    {
                        label: '商品',
                        value: 3
                    },
                    {
                        label: '商品分类',
                        value: 4
                    },
                    {
                        label: '详情页',
                        value: 5
                    }
                ],
                
                firstCategoryOptions: [], // 一级分类
                firstCategoryOptionsLoading: false,
                secondCategoryOptions: [], // 二级分类
                secondCategoryOptionsLoading: false,

                optionsLoading: false,
                options: [],

                commodityList: { // 选中的指定商品
                    ids: [],
                    tableLoading: false,
                    tableData: [],
                    page: {
                        current: 1,
                        size: 99999,
                        total: 0
                    }
                }
            }
        },
        mounted() {
            this.getDetail();
        },
        methods: {
            /**
             * [getDetail description] 获取详情
             * @param  {[type]} val [description]
             * @return {[type]}     [description]
             */
            getDetail: function() {
                if(!this.id) {
                    this.pageLoading = false;
                    return false;
                }

                this.pageLoading = true;

                let params = {
                    id: this.id
                }

                shopComponentServiceDetail(params).then(res =>{
                    this.pageLoading = false;

                    let { code, data, msg } = res;

                    if(code == 0) {
                        this.formData.keyword = data.keyword;
                        this.formData.title = data.title;
                        if(data.pic) {
                            this.formData.pics = [{
                                name: data.path,
                                percentage: 100,
                                status: 'success',
                                url: data.picPath,
                                response: {
                                    data: {
                                        url: data.pic,
                                        path: data.picPath
                                    }
                                }
                            }];
                        }
                        this.formData.redirectType = data.redirectType;
                        this.formData.firstCategoryId = data.firstCategoryId || '';
                        this.formData.secondCategoryId = data.secondCategoryId || '';
                        this.formData.productId = data.redirectType == 5 ? data.relationIds[0] : (data.productId || '');
                        this.formData.relationIdList = data.relationIds || [];

                        this.handleGetRelatedGoodsList();

                        if(data.redirectType == 1) {
                            this.getServiceList()
                        } else if(data.redirectType == 3) {
                            this.getGoodsList()
                        } else if(data.redirectType == 2 || data.redirectType == 4) {
                            this.getFirstCategoryList()
                            if(data.firstCategoryId) {
                                this.handleFirstCategoryChange('detail')
                            }
                        } else if(data.redirectType == 5) {
                            this.getDetailList()
                        }
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    console.log(error)
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [handleRedirectTypeChange description] 链接至 - 变化
             * @return {[type]} [description]
             */
            handleRedirectTypeChange() {
                let redirectType = this.formData.redirectType
                this.commodityList.tableData = []
                if(redirectType == 1) {
                    // 服务
                    this.formData.relationIdList = []
                    this.formData.productId = ''
                    this.options = []
                    this.getServiceList()
                } else if(redirectType == 3) {
                    // 商品
                    this.formData.relationIdList = []
                    this.formData.productId = ''
                    this.options = []
                    this.getGoodsList()
                } else if(redirectType == 2 || redirectType == 4) {
                    // 商品分类
                    this.formData.firstCategoryId = ''
                    this.formData.secondCategoryId = ''
                    this.secondCategoryOptions = []
                    this.getFirstCategoryList()
                } else if(redirectType == 5) {
                    // 广告详情页
                    this.formData.productId = ''
                    this.options = []
                    this.getDetailList()
                }
            },
            /**
             * [getServiceList description] 获取项目列表
             * @return {[type]}         [description]
             */
            getServiceList() {
                this.optionsLoading = true;

                let params = {
                    current: this.commodityList.page.current,
                    size: this.commodityList.page.size
                }
                serviceManageList(params).then(res =>{
                    this.optionsLoading = false;

                    let { code, data, msg } = res;

                    if(code == 0) {
                        let dataArray = data.records || [];

                        dataArray.map((item, index) => {
                            if(!item) {
                                dataArray.splice(index, 1);
                            }
                        })

                        this.options = dataArray;
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [getGoodsList description] 获取商品
             * @return {[type]}         [description]
             */
            getGoodsList() {
                this.optionsLoading = true;

                let params = {
                    all: 1,
                    type: '',
                    relateId: '',
                    commodityName: '',
                    current: 1,
                    size: 99999
                }

                commodityFilterList(params).then(res =>{
                    this.optionsLoading = false;

                    let { code, data, msg } = res;

                    if(code == 0) {
                        let dataArray = data.records || [];

                        this.options = dataArray;
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [getFirstCategoryList description] 获取类目
             * @return {[type]}         [description]
             */
            getFirstCategoryList: function() {
                this.firstCategoryOptionsLoading = true;

                let params = {
                    type: this.formData.redirectType == 2 ? 2 : 1
                }

                commodityCategoryList(params).then(res => {
                    let { code, data, msg } = res;

                    if(code == 0) {
                        let dataArray = data || [];
                        
                        this.firstCategoryOptions = dataArray;
                        this.firstCategoryOptionsLoading = false;
                    }
                });
            },
            /**
             * [handleFirstCategoryChange description] 监测一级类目下拉框值变化
             * @param  {[type]} val [description] 
             * @return {[type]}     [description]
             */
            handleFirstCategoryChange: function(type) {
                if(type != 'detail') {
                    this.formData.secondCategoryId = ''
                }

                this.secondCategoryOptionsLoading = true;

                let params = {
                    type: this.formData.redirectType == 2 ? 2 : 1,
                    firstCategoryId: this.formData.firstCategoryId
                }

                commodityCategoryList(params).then(res => {
                    let { code, data, msg } = res;

                    if(code == 0) {
                        let dataArray = data || [];
                        
                        this.secondCategoryOptions = dataArray;
                        this.secondCategoryOptionsLoading = false;
                    }
                });
            },
            /**
             * [getDetailList description] 获取详情页
             * @return {[type]}         [description]
             */
            getDetailList() {
                this.optionsLoading = true;

                let params = {
                    current: 1,
                    size: 99999
                }

                shopPosterPageList(params).then(res =>{
                    this.optionsLoading = false;

                    let { code, data, msg } = res;

                    if(code == 0) {
                        let dataArray = data.records || [];

                        this.options = dataArray;
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.$message.error('服务器异常');
                });
            },

            // ==============================================================================================================================
            /**
            * [handleRelatedGoodsDialogShow description] 指定商品 - 弹窗 - 显示
            * [handleRedirectTypeChange description] 链接至 - 变化
            * @return {[type]} [description]
            */
            handleRelatedGoodsDialogShow: function() {
                this.commodityList.ids = JSON.parse(JSON.stringify(this.formData.relationIdList));
                this.$refs.goodsRelate.handleDialogShow();
            },
            /**
            * [getRelatedGoodsIds description] 指定商品 - 弹窗 - 选中的数据id集合
            * @param  {[type]} ids [description]
            * @return {[type]}     [description]
            */
            getRelatedGoodsIds: function(ids) {
                this.formData.relationIdList = ids;
                this.handleGetRelatedGoodsList();
            },
            /**
             * [handleGetRelatedGoodsList description] 指定商品 - 根据选中数据的id集合获取商品列表
             * @return {[type]} [description]
            */
            handleGetRelatedGoodsList: function() {
                if(this.formData.relationIdList.length === 0) {
                    return false
                }

                let redirectType = this.formData.redirectType
                if(redirectType == 1) {
                    // 服务
                    this.commodityList.tableLoading = true;

                    let params = {
                        idStr: this.formData.relationIdList.join(','),
                        current: this.commodityList.page.current,
                        size: this.commodityList.page.size
                    }

                    serviceManageList(params).then(res =>{
                        this.commodityList.tableLoading = false;

                        let { code, data, msg } = res;

                        if(code == 0) {
                            let dataArray = data.records || [];

                            dataArray.map((item, index) => {
                                if(!item) {
                                    dataArray.splice(index, 1);
                                }
                            })

                            this.commodityList.tableData = dataArray;
                            this.commodityList.page.total = data.total;
                        } else {
                            this.$message.error(msg);
                        }
                    }).catch(error => {
                        this.$message.error('服务器异常');
                    });
                } else if(redirectType == 3) {
                    // 商品
                    this.commodityList.tableLoading = true;

                    let params = {
                        catType: 1,
                        idStr: this.formData.relationIdList.join(','),
                        current: this.commodityList.page.current,
                        size: this.commodityList.page.size
                    }

                    commodityFilterList(params).then(res =>{
                        this.commodityList.tableLoading = false;

                        let { code, data, msg } = res;

                        if(code == 0) {
                            let dataArray = data.records || [];

                            dataArray.map((item, index) => {
                                if(!item) {
                                    dataArray.splice(index, 1);
                                }
                            })

                            this.commodityList.tableData = dataArray;
                            this.commodityList.page.total = data.total;
                        } else {
                            this.$message.error(msg);
                        }
                    }).catch(error => {
                        this.$message.error('服务器异常');
                    });
                }
            },
            /**
             * [handleCommodityListPageChange description] 指定商品 - 列表 - 切换分页
             * @param  {[type]} val [description]
             * @return {[type]}     [description]
             */
            handleCommodityListPageChange: function(val) {
                this.commodityList.page.current = val;
                this.handleGetRelatedGoodsList();
            },
            /**
             * [handleCommodityListRowRemove description] 指定商品 - 列表 - 移除
             * @param  {[type]} row   [description]
             * @param  {[type]} index [description]
             * @return {[type]}       [description]
             */
            handleCommodityListRowRemove: function(row, index) {
                let tableData = this.commodityList.tableData,
                    ids = this.formData.relationIdList;
                tableData.splice(index, 1);
                ids.splice(ids.indexOf(row.id), 1);
                this.commodityList.page.total -= 1;
            },
            // ==============================================================================================================================
            /**
             * [handleSave description] 保存
             * @return {[type]} [description]
             */
            handleSave: function() {
                console.log('this.formData', this.formData)
                if(this.formData.pics.length == 0) {
                    this.$message.error('请上传图片');
                    return false;
                }

                if(!this.formData.keyword) {
                    this.$message.error('请输入关键词');
                    return false;
                }

                if(!this.formData.title) {
                    this.$message.error('请输入标题');
                    return false;
                }

                if(!this.formData.redirectType) {
                    this.$message.error('请选择链接至');
                    return false;
                }
                let redirectType = this.formData.redirectType
                if(redirectType == 1) {
                    // 服务
                    if(this.formData.relationIdList.length == 0) {
                        this.$message.error('请选择项目');
                        return false;
                    }
                } else if(redirectType == 3) {
                    // 商品
                    if(this.formData.relationIdList.length == 0) {
                        this.$message.error('请选择商品');
                        return false;
                    }
                } else if(redirectType == 2 || redirectType == 4) {
                    // 商品分类
                    if(!this.formData.firstCategoryId) {
                        this.$message.error('请选择一级分类');
                        return false;
                    }
                    if(!this.formData.secondCategoryId) {
                        this.$message.error('请选择二级分类');
                        return false;
                    }
                } else if(redirectType == 5) {
                    // 商品
                    if(!this.formData.productId) {
                        this.$message.error('请选择详情页');
                        return false;
                    }
                }

                this.submitLoading = true;

                let params = {
                    recommendId: this.id,
                    pic: this.formData.pics[0].response.data.url,
                    title: this.formData.title,
                    keyword: this.formData.keyword,
                    redirectType: this.formData.redirectType,
                    firstCategoryId: this.formData.firstCategoryId,
                    secondCategoryId: this.formData.secondCategoryId,
                    productId: this.formData.productId,
                    relationIdList: redirectType == 5 ? [this.formData.productId] : this.formData.relationIdList
                }

                shopComponentServiceRecommendSaveOrUpdate(params).then(res =>{
                    this.submitLoading = false;

                    let { code, data, msg } = res;

                    if(code == 0) {
                        this.$message({ message: '保存成功', type: 'success' });

                        this.$router.push({ path: '/shop/component/list', query: { name: '0' } });
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.submitLoading = false;
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [pageLinkToComponentList description] 取消
             * @return {[type]} [description]
             */
            pageLinkToComponentList: function() {
                this.$router.push({ path: '/shop/component/list', query: { name: '0' } });
            },
            /**
             * [handleDetailPicturesBeforeUpload description] 图片上传之前格式校验
             * @param  {[type]} file [description]
             * @return {[type]}      [description]
             */
            handlePicBeforeUpload: function(file) {
                let fileName = file.name,
                    fileNameArr = fileName.split('.'),
                    fileType = fileNameArr[fileNameArr.length - 1],
                    supportArr = ['jpg', 'jpeg', 'png'];

                if(supportArr.indexOf(fileType) == -1) {
                    this.$message.error('请上传jpg、jpeg、png格式的图片');
                    return false;
                }
            },
            handlePicPreview: function(file) {
                this.previewDialogImageUrl = file.url;
                this.previewDialogShow = true;
            },
            handlePicSuccess: function(response, file, fileList) {
                this.formData.pics = fileList;
            },
            handlePicError: function(err, file, fileList) {
                this.$message.error('图片上传失败');
                this.formData.pics = fileList;
            },
            handlePicRemove: function(file, fileList) {
                this.formData.pics = fileList;
            },

            /**
             * [handleTableRowSort description] 给表格每一行绑定移动事件
             * @return {[type]} [description]
             */
            handleTableRowSort: function() {
                let table = document.getElementsByClassName('el-table__body'),
                    tableTR;

                if(!table[0] || this.commodityList.tableData.length == 0) {
                    return false;
                }

                tableTR = table[0].getElementsByTagName('tr');

                for(let i = 0; i < tableTR.length; i++) {
                    tableTR[i].draggable = false;
                    tableTR[i].style.cursor = 'auto';
                    tableTR[i].removeEventListener('dragstart', this.handleTableTRDragStart);
                    tableTR[i].removeEventListener('dragover', this.handleTableTRDragover);
                    tableTR[i].removeEventListener('drop', this.handleTableTRDrop);
                }

                for(let i = 0; i < tableTR.length; i++) {
                    let tableTRItem = tableTR[i];
                    
                    tableTRItem.draggable = true;
                    tableTRItem.setAttribute('data-index', i);
                    tableTRItem.style.cursor = 'all-scroll';

                    tableTRItem.addEventListener('dragstart', this.handleTableTRDragStart, false);
                    tableTRItem.addEventListener('dragover', this.handleTableTRDragover, false);
                    tableTRItem.addEventListener('drop', this.handleTableTRDrop, false);
                }
            },
            /**
             * [handleTableTRDragStart description] 拖动开始，设置携带的参数
             * @param  {[type]} ev [description] 拖动对象
             * @return {[type]}    [description]
             */
            handleTableTRDragStart: function(ev) {
                ev.dataTransfer.setData('index', ev.target.dataset.index);
            },
            /**
             * [handleTableTRDragover description] 必须要 preventDefault, 否则不会触发 drop
             * @param  {[type]} ev [description]
             * @return {[type]}    [description]
             */
            handleTableTRDragover: function(ev) {
                ev.preventDefault();
            },
            /**
             * [handleTableTRDrop description] 拖动释放触发的方法
             * @param  {[type]} ev [description] 目标对象
             * @return {[type]}    [description]
             */
            handleTableTRDrop: function(ev) {
                ev.preventDefault();

                let originalIndex = ev.dataTransfer.getData('index'),
                    trNode = this.handleGetTRNode(ev.target),
                    targetIndex = trNode.getAttribute('data-index');

                if(originalIndex == targetIndex) { // 原地释放
                    return false;
                }
                
                // 将移动的对象插入目标对象之前
                let originalObject = this.commodityList.tableData.splice(originalIndex, 1),
                    originalId = this.formData.relationIdList.splice(originalIndex, 1);
                this.commodityList.tableData.splice(targetIndex, 0, originalObject[0]);
                this.formData.relationIdList.splice(targetIndex, 0, originalId[0]);

                // do request
                this.handleGetRelatedGoodsList();
            },
            /**
             * [handleGetTRNode description] 循环查找dom父节点，直到匹配到tr
             * @param  {[type]} ob [description] 当前dom节点
             * @return {[type]}    [description]
             */
            handleGetTRNode: function(ob) {
                if(ob.tagName == 'TR') {
                    return ob;
                } else {
                    return this.handleGetTRNode(ob.parentNode);
                }            
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../../common/styles/base/mixin-font";
    @import "../../../common/styles/base/mixin-common";

    .thumb-wrap{
        position: relative;
        display: inline-block;
        margin-right: 10px;
        vertical-align: middle;
        width: 48px;
        height: 48px;
        background-color: $colorPageBg;

        img{
            max-width: 100%;
            max-height: 100%;
            @include position(absolute, 1, 50%, none, none, 50%);
            @include translate(-50%, -50%, 0);
        }
    }

    .form-wrap{
        padding: 10px 35px;
        // background: $colorPageBg;
    }

    .block-item{
        .label{
            width: 5em;
            text-align: right;

            .required-icon{
                color: #F56C6C;
            }
        }
    }

    .pics-box{
        ::v-deep .el-upload-list--picture-card{
            .el-upload-list__item{
                position: relative;
                width: 100px;
                height: 100px;
                border-radius: 2px;

                .el-upload-list__item-thumbnail{
                    @include position(absolute, none, 50%, none, none, 50%);
                    @include translate(-50%, -50%, 0);
                }

                .el-progress{
                    width: 80px;
                    height: 80px;

                    .el-progress-circle{
                        width: 80px !important;
                        height: 80px !important;
                    }
                }

                .el-icon-close-tip{
                    display: none;
                }
            }
        }

        ::v-deep .el-upload--picture-card{
            width: 100px;
            height: 100px;
            line-height: 98px;
            border-radius: 2px;

            .el-upload-dragger{
                width: 98px;
                height: 98px;
                border: none;

                .el-icon-plus{
                    font-size: $baseFS;
                }
            }
        }
    }

    .category-pics-box{
        .pics-box{
            width: 100px;
            height: 100px;
            overflow: hidden;
        }
    }

    .label-pics-box{
        .pics-box{
            width: 70px;
            height: 70px;
            overflow: hidden;

            ::v-deep .el-upload-list--picture-card{
                .el-upload-list__item{
                    width: 70px;
                    height: 70px;

                    .el-progress{
                        width: 560px;
                        height: 56px;

                        .el-progress-circle{
                            width: 56px !important;
                            height: 56px !important;
                        }
                    }
                }
            }

            ::v-deep .el-upload--picture-card{
                width: 70px;
                height: 70px;
                line-height: 68px;

                .el-upload-dragger{
                    width: 68px;
                    height: 68px;
                }
            }
        }
    }
</style>

